import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "chart" };
const _hoisted_2 = {
    key: 0,
    class: "chart__title"
};
import { onMounted } from 'vue';
import { Chart, LineController, LineElement, PointElement, CategoryScale, LinearScale, Colors, Legend, } from "chart.js";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LineChart',
    props: {
        label: {},
        data: {},
        options: {}
    },
    setup(__props) {
        const props = __props;
        const id = 'chart' + Math.random();
        const defaultOptions = {
            responsive: true,
        };
        Chart.register(LineController, LineElement, PointElement, CategoryScale, LinearScale, Colors, Legend);
        onMounted(() => {
            const options = { ...defaultOptions, ...props.options || {} };
            const ctx = document.getElementById(id);
            new Chart(ctx, {
                type: 'line',
                data: props.data,
                options: options,
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.label)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(__props.label), 1))
                    : _createCommentVNode("", true),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("canvas", {
                    id: id,
                    class: "chart__canvas"
                })
            ]));
        };
    }
});
